import axios from 'axios';
import serverMessage from '../server-message';

export default function setStatus({ id, isActive }) {
  return new Promise((resolve, reject) => axios
    .patch(`/account/system-admin/api/v1/bundle/${id}/status`, {
      is_active: isActive,
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(serverMessage(error))));
}
